import { render, staticRenderFns } from "./LangsList.vue?vue&type=template&id=504e31a6"
import script from "./LangsList.vue?vue&type=script&lang=js"
export * from "./LangsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports